import React from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'

import { ClassesType } from '../../types'
import PlusButton from './PlusButton'

const useStyles = makeStyles(
  theme => ({
    addContainer: {
      height: '100%',
    },
    addItem: {
      cursor: 'pointer',
      borderRadius: '4px 4px 0 0',
      width: '100%',
    },
    inline: {
      display: 'inline-block',
      width: 'auto',
      marginRight: theme.spacing(2),
    },
    addItemDashed: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      border: '1px dashed #9F9B9B',
    },
    addItemDisabled: {
      cursor: 'default',
      pointerEvents: 'none',
    },
    addText: {
      fontWeight: 500,
    },
    plusButton: {
      margin: theme.spacing(0, 1, 0, 0),
    },
    plusButtonDashed: {
      marginLeft: theme.spacing(1),
    },
    plusIcon: {},
  }),
  { name: 'AddButton' },
)

export interface AddButtonProps {
  readonly addText?: React.ReactNode
  readonly classes?: ClassesType<typeof useStyles>
  readonly disabled?: boolean
  readonly inline?: boolean
  readonly onAdd?: () => void
  readonly plusButtonClass?: string
  readonly variant?: 'normal' | 'dashed'
}

const AddButton = ({
  classes: classesProp,
  inline,
  disabled,
  onAdd,
  addText,
  plusButtonClass,
  variant = 'normal',
}: AddButtonProps) => {
  const classes = useStyles({ classes: classesProp })

  const isDashed = variant === 'dashed'

  return (
    <div
      className={classNames(classes.addItem, {
        [classes.inline]: inline,
        [classes.addItemDashed]: isDashed,
        [classes.addItemDisabled]: disabled,
      })}
      onClick={onAdd}
    >
      <Grid
        container
        alignItems="center"
        className={classes.addContainer}
        justifyContent="flex-end"
      >
        <PlusButton
          classes={{
            label: classes.addText,
            iconContainer: classNames(classes.plusButton, plusButtonClass, {
              [classes.plusButtonDashed]: isDashed,
            }),
            icon: classes.plusIcon,
          }}
          label={addText}
        />
      </Grid>
    </div>
  )
}

export default AddButton
